export default {
  data() {
    return {
      customerOptions: [
        {
          ORMTB410ID: '',
          ORMTB410CA00: '全部',
        },
      ],
      filteredCustomerOptions: [],
      customerOptionsAll: [],
    }
  },
  methods: {
    enterprise0ptions() {
      var postData = {}
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        postData = {
          ORMTB400ID: this.uobj.ormtb410.ORMTB410ID,
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        postData = {
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
        }
      }
      var List = [
        {
          ORMTB410ID: '',
          ORMTB410CA00: '全部',
        },
      ]
      this.axios.post('/orm/ormtb410/selectOrmtb410s', postData).then(res => {
        if (res.data.code == 200) {
          this.customerOptions = [...List, ...res.data.data]
          this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
          this.customerOptionsAll = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    filterCustomer(query) {
      if (!query) {
        this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredCustomerOptions = this.customerOptions.filter(
        item =>
          (item.ORMTB410CA00 || '').toLowerCase().includes(q) ||
          (item.ORMTB410CA13 || '').toLowerCase().includes(q)
      )
    },
  },
}
